import {
  createApiRef,
  type DiscoveryApi,
  type FetchApi,
} from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import type { LeaderboardResponse } from '@internal/backstage-plugin-scorecard-common';

export interface ScorecardLeaderboardApi {
  /** Every Group of `type` (default `team`) with its scorecard results — unranked. */
  getLeaderboard(options?: { type?: string }): Promise<LeaderboardResponse>;
}

export const scorecardLeaderboardApiRef = createApiRef<ScorecardLeaderboardApi>(
  { id: 'plugin.scorecard.leaderboard' },
);

/** Client for the backend's `GET /api/tech-insights/scorecard-leaderboard`. */
export class ScorecardLeaderboardClient implements ScorecardLeaderboardApi {
  private readonly discoveryApi: Pick<DiscoveryApi, 'getBaseUrl'>;
  private readonly fetchApi: Pick<FetchApi, 'fetch'>;

  constructor(options: {
    discoveryApi: Pick<DiscoveryApi, 'getBaseUrl'>;
    fetchApi: Pick<FetchApi, 'fetch'>;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getLeaderboard(
    options: { type?: string } = {},
  ): Promise<LeaderboardResponse> {
    const baseUrl = await this.discoveryApi.getBaseUrl('tech-insights');
    const params = new URLSearchParams({ type: options.type ?? 'team' });
    const res = await this.fetchApi.fetch(
      `${baseUrl}/scorecard-leaderboard?${params}`,
    );
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    return res.json();
  }
}
